import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";
import frIcon from "@/assets/fr-icon.svg";
import enIcon from "@/assets/en-icon.svg";

const LANGUAGES = [
  { code: "fr", icon: <img src={frIcon} alt="EN" className="size-5" /> },
  { code: "en", icon: <img src={enIcon} alt="EN" className="size-5" /> },
] as const;

const LanguageSetting = () => {
  const { t, i18n } = useTranslation();

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value);
  };

  return (
    <div className="space-y-2">
      <Label
        htmlFor="language-select"
        className="flex items-center gap-2 text-sm font-medium"
      >
        <Languages className="size-4" />
        {t("settings.personal_preferences.title")}
      </Label>
      <p className="text-muted-foreground text-sm">
        {t("settings.language_description")}
      </p>
      <Select value={i18n.language} onValueChange={handleLanguageChange}>
        <SelectTrigger id="language-select" className="w-full">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {LANGUAGES.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              <span className="flex items-center gap-2">
                <span>{lang.icon}</span>
                <span>{t(`languages.${lang.code}`)}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default LanguageSetting;
